export enum MonitoringRoutes {
    consultants = 'consultants',
    client = 'client',
    notes = 'notes',
    export = 'export',
}
